export const breadcrumbsSizes = {
  s: 's',
  m: 'm',
}

export const breadcrumbsTextSizes = {
  [breadcrumbsSizes.s]: 'captionL',
  [breadcrumbsSizes.m]: 'pS',
} as const
